import React, { FC } from "react";
import DeliveredTo from "../../delivery/deliveredTo";
import CartDeliveryType from "../../cart/cartDeliveryType";
import { DeliveryInfo } from "@/components/product/webSizes/types";

type Props = {
  deliveryInfo: DeliveryInfo[];
};

const ProductDeliveryInfo: FC<Props> = ({ deliveryInfo }) => (
  <div>
    <DeliveredTo />
    <div className="applePayDeliveryType_wrapper">
      <div className="applePayDeliveryType">
        <CartDeliveryType deliveryInfo={deliveryInfo} />
      </div>
    </div>
  </div>
);

export default ProductDeliveryInfo;
